/** Dispatched when a column's async card list changes so the board can re-measure. */
export const DASHBOARD_GRID_LAYOUT_SYNC_EVENT = "dashboard-grid-layout-sync";

export const requestDashboardGridLayoutSync = () => {
  window.dispatchEvent(new Event(DASHBOARD_GRID_LAYOUT_SYNC_EVENT));
};
